import Cookies from "js-cookie";

export default {
  namespaced: true,
  state: {
    options: {
      url: null,
      // acceptedFiles: '.psd,.pdd,.psdt,.psb,.pdf,.tif,.tiff,.eps,.ai,.jpg,.jpeg,.jpe,.jp2,.png,.tga,.bmp,.gif,.doc,.docx,.svg,.webp,.cr2,.crw,.dcr,.dng,.exr,.epdf,.heic,.nef,.orf,.wmf,.cdr,.emb',
      acceptedFiles: [
        ".psd",
        ".pdd",
        ".psdt",
        ".psb",
        ".pdf",
        ".tif",
        ".tiff",
        ".eps",
        ".ai",
        ".jpg",
        ".jpeg",
        ".jpe",
        ".jp2",
        ".png",
        ".tga",
        ".bmp",
        ".gif",
        ".doc",
        ".docx",
        ".svg",
        ".webp",
        ".cr2",
        ".crw",
        ".dcr",
        ".dng",
        ".exr",
        ".epdf",
        ".heic",
        ".nef",
        ".orf",
        ".wmf",
        ".cdr",
        ".emb",
        ".erf",
        ".nrw",
        ".pef",
        ".raf",
        ".rw2",
      ],
      parallelUploads: 5,
      uploadMultiple: false,
      headers: {
        Authorization: "Bearer " + Cookies.get("token"),
      },
    },
  },
  getters: {
    options(state) {
      return state.options;
    },
  },
  mutations: {
    SET_URL(state, url) {
      state.options.url = url;
    },
  },
  actions: {
    setUrl({ commit }, payload) {
      commit("SET_URL", payload.url);
    },
  },
};
